import { createSlice } from '@reduxjs/toolkit';
import type { NormalizedError } from 'errors/types';
import type { RootState } from 'state/store';

export type RetrieveQuoteState = {
  isLoading: boolean;
  errors: NormalizedError[] | null;
  details: {
    postcode: string | null;
    email: string | null;
  };
  data: Record<string, unknown>;
};

export const initialState: RetrieveQuoteState = {
  isLoading: false,
  errors: null,
  details: {
    postcode: null,
    email: null
  },
  data: {}
};

export const slice = createSlice({
  name: 'retrieveQuote',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = {};
      state.errors = payload;
    },
    setFormField: (state, { payload: { name, value } }) => {
      state.details[name] = value;
    }
  }
});

export const {
  setInitialState,
  setFormField,
  setSuccess,
  setError,
  setIsLoading
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectDetails = (state: RootState) => selectSlice(state).details;
export const selectIsLoading = (state: RootState) =>
  selectSlice(state).isLoading;
export const selectErrors = (state: RootState) => selectSlice(state).errors;
export const selectData = (state: RootState) => selectSlice(state).data;

export default slice.reducer;
